<template>
   <v-col  class="col-md-4 col-4">
    <v-card>
      <v-img  :src="src" aspect-ratio="2" class="grey lighten-2">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-title primary-title>
        <v-row>
          <v-col cols="6">{{ title }}</v-col>
          <v-col cols="6" class="text-right">
            <v-btn icon color="red" class="btn-card" @click="dialogDelete=true">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>

    <v-dialog v-model="dialogDelete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          ต้องการลบข้อมูล?
        </v-card-title>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogDelete=false;">
            ยกเลิก
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DeleteConfirm">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          ลบข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickDeleteComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-col>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: Number,
    src: String,
    id: Number
  },
  data() {
    return {
      dialogDelete:false,
      dialogDeleteComplete:false,
    };
  },
  methods: {
    GetData(){
      this.$emit('complete');
    },
    DeleteConfirm(){
      this.dialogDelete = false;
      this.$store.commit('set_overlay',true);
      let formData = new FormData();
      formData.append('id',this.id);
      this.req.post(this.$store.getters.base_api + 'delete-upload-slide',formData)
      .then(response=>{
        this.dialogDeleteComplete = true;
      }).catch(error => {

      });
    },
    ClickDeleteComplete(){
      this.dialogDeleteComplete = false;
      this.$emit('complete');
    },
  },mounted() {
    this.req = this.$store.getters.req;
  },
};
</script>
<style type="text/css">

.btn-card.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #ff000000 !important;
    color: #fff;
}
</style>